import { useState, useEffect } from "react";
import apiInstance from "../../services/ServiceApi";
import { Button, CircularProgress, Modal, TextField, Typography } from "@mui/material";

const ModalEnviarMensaje = ({ telefono: initialTelefono, cliente_id, onClose ,codigo_llamada =""}) => {
    const [telefono, setTelefono] = useState(initialTelefono);
    const [speech, setSpeech] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    // Realizar la solicitud para obtener el mensaje al cargar el componente
    useEffect(() => {
        const obtenerMensajeCliente = async () => {
        try {
            const response = await apiInstance.get(`sms/speech/cliente/${cliente_id}/`);
            const data = response.data;
            setSpeech(data);
            setMensaje(data.mensaje);
        } catch (error) {
            setError(error.response ? error.response.data : "Hubo un error al obtener el mensaje");
        }
        };

        obtenerMensajeCliente();
    }, [cliente_id]);

    const handleEnviarMensaje = async () => {
        const payload = {
            texto: speech.mensaje,
            numero_contacto: telefono,
            cliente: cliente_id,
            linea_negocio_id: speech.linea_negocio_id,
            identificador: speech.identificador,
            codigo_llamada: codigo_llamada
        };
        setLoading(true)
        setTimeout(() => {
            onClose();
        }, 600);
        
    
        try {
            // Llamada a la API sin esperar la respuesta
            await apiInstance.post('sms/cliente/', payload);
            
        } catch (error) {
            // Manejo de errores
            setError(error.response ? error.response.data : "Hubo un error al enviar el mensaje");
        } finally {
            // Establecer loading a false independientemente del resultado de la solicitud
            setLoading(false);
        }

    };
    

    return (
        <Modal open={true} onClose={onClose}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', padding: '20px', borderRadius: '8px' }}>
            {loading && <CircularProgress size={24} />}  
            <Typography variant="h6" gutterBottom>
            Enviar Mensaje a
            </Typography>
            <TextField
            label="Número de Teléfono"
            variant="outlined"
            fullWidth
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            style={{ marginBottom: '20px' }}
            />
            <TextField
            label="Mensaje"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
            style={{ marginBottom: '20px' }}
            />
            {/* Mostrar el mensaje de error si existe */}
            {error && (
            <Typography variant="body2" color="error" style={{ marginBottom: '10px' }}>
                {error}
            </Typography>
            )}
            {/* Botones para enviar y cancelar */}
            <Button variant="contained" color="primary" onClick={handleEnviarMensaje} style={{ marginRight: '10px' }} >Enviar</Button>
            <Button variant="contained" onClick={onClose}>Cancelar</Button>
        </div>
        </Modal>
  );
};

export default ModalEnviarMensaje;
